module.exports = __webpack_public_path__ + "img/scop7.7b55dda3.jpg";